import * as fromTenantActions from './operacional-tenant.actions';

export const initialState: any = {
  usuario: {},
};

export function reducer(
  state = initialState,
  action: fromTenantActions.TenantActions
): any {
  switch (action.type) {
    case fromTenantActions.TenantActionTypes.TENANT_ALL:
      return state;
    case fromTenantActions.TenantActionTypes.TENANT_NEW:
      return (state = action.payload.operacionalTenant);
    default:
      return state;
  }
}
